module.exports = __webpack_public_path__ + "media/packs/images/flags/NG-80ae6b73556b4214bf26dbece0a380d1.svg";